import { createReducer } from '@reduxjs/toolkit';

const VehicleTypeInitialState = {
    loading: false,
    UserInfo: {},
    PickedStudentField: "",
    StartRecordingField: "",
    error: "",
    VLIAgentsData: "",
    InstituteData: "",
    LearnerClassInitiatedOTP: "",
    LearnerAllDrivingClassesData: "",
    VliBlogsData:"",
    VliBlogsDataById:"",
    InstituteExpenseData: "",
    ConfirmedInstitutesLearnersData:"",
}
export const LoginSignupReducer = createReducer(VehicleTypeInitialState, (builder) => {
    //Login
    builder.addCase("LoginRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("LoginSuccess", (state, action) => {
        state.loading = false;
        state.UserInfo = action.payload;
        state.Authenticated = action.Auth;
        state.error = {};
    })
    builder.addCase("EnrollmentSuccess", (state, action)=> {
        state.UserInfo = action.payload;
    })
    builder.addCase("LoginError", (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Empty payload clears the form error only (see LoginUser success); do not log out.
        if (action.payload && Object.keys(action.payload).length > 0) {
            state.Authenticated = false;
        }
    })


    //Signup
    builder.addCase("SignUpRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("SignUpSuccess", (state, action) => {
        state.loading = false;
        state.UserInformation = action.payload;
        state.Authenticated = action.Auth;
        state.error = {};
    })
    builder.addCase("SignUpError", (state, action) => {
        state.loading = false;
        state.error = action.payload
        state.Authenticated = false;
    })

    //verify Otp
    builder.addCase("verifyOtpRequest", (state, action)=> {
       state.loading = false
    })
    builder.addCase("verifyOtpSuccess", (state, action)=> {
        state.loading = false;
        state.UserInfo = action.payload;
        state.Authenticated = action.Auth;
        state.error = {};
    })
    builder.addCase("VerifyOtpError", (state, action)=> {
        state.loading = false;
        state.error = action.payload;
        state.Authenticated = false;
    })

    // Register
    builder.addCase("RegisterInstituteRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("RegisterInstituteSuccess", (state, action) => {
        state.loading = false;
        state.UserInfo = action.payload;
        state.Authenticated = action.Auth;
        state.error = {};
    })
    builder.addCase("RegisterInstituteError", (state, action) => {
        state.loading = false;
        state.error = action.payload
        state.Authenticated = false;
    })

    // RegisterVLIBlogsData
    builder.addCase("RegisterVLIBlogsDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("RegisterVLIBlogsDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("RegisterVLIBlogsDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // FetchAllVLIBlogsData
    builder.addCase("FetchAllVLIBlogsDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchAllVLIBlogsDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.VliBlogsData = action.payload;
    })
    builder.addCase("FetchAllVLIBlogsDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

     // FetchAllConfirmedInstitutesLearnersData
     builder.addCase("FetchAllConfirmedInstitutesLearnersDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchAllConfirmedInstitutesLearnersDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.ConfirmedInstitutesLearnersData = action.payload;
    })
    builder.addCase("FetchAllConfirmedInstitutesLearnersDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // FetchVLIBlogById
    builder.addCase("FetchVLIBlogByIdRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchVLIBlogByIdSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.VliBlogsDataById = action.payload;
    })
    builder.addCase("FetchVLIBlogByIdError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // DeleteVLIBlogsDataA
    builder.addCase("DeleteVLIBlogsDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("DeleteVLIBlogsDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("DeleteVLIBlogsDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    
    // RegisterInstituteExpenseData
    builder.addCase("RegisterInstituteExpenseDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("RegisterInstituteExpenseDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("RegisterInstituteExpenseDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // FetchAllInstituteExpenseData
    builder.addCase("FetchAllInstituteExpenseDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchAllInstituteExpenseDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteExpenseData = action.payload;
    })
    builder.addCase("FetchAllInstituteExpenseDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

     // DeleteInstituteExpenseData
     builder.addCase("DeleteInstituteExpenseDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("DeleteInstituteExpenseDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("DeleteInstituteExpenseDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })



     // UpdateHeardAboutUsData
     builder.addCase("UpdateHeardAboutUsDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("UpdateHeardAboutUsDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("UpdateHeardAboutUsDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // CheckoutPaymentSuccess
    builder.addCase("CheckoutPaymentSuccessRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("CheckoutPaymentSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("CheckoutPaymentSuccessError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // CheckoutPaymentFailure
    builder.addCase("CheckoutPaymentFailureRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("CheckoutPaymentFailureSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("CheckoutPaymentFailureError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // SavingInstituteFormInJson
    builder.addCase("SavingInstituteFormInJsonRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("SavingInstituteFormInJsonSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("SavingInstituteFormInJsonError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // GetInstituteDataAndSendOtp
    builder.addCase("GetInstituteDataAndSendOtpRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("GetInstituteDataAndSendOtpSuccess", (state, action) => {
        state.loading = false;
        state.InstituteData = action.payload;
        state.error = {};
    })
    builder.addCase("GetInstituteDataAndSendOtpError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // GetVLIAgentsA
    // builder.addCase("GetVLIAgentsARequest", (state, action) => {
    //     state.loading = true;
    // })
    // builder.addCase("GetVLIAgentsASuccess", (state, action) => {
    //     state.loading = false;
    //     state.VLIAgentsData = action.payload;
    // })
    // builder.addCase("GetVLIAgentsAError", (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload
    // })

    //get picked student field fom users table
    builder.addCase("GetPickedStudentFromUsersRequest", (state, action) => {
        state.loading = true;
    })

    builder.addCase("GetPickedStudentFromUsersSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.PickedStudentField = action.payload
    })
    builder.addCase("GetPickedStudentFromUsersError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    //get start recording field fom users table
    builder.addCase("GetStartRecordingFromUsersRequest", (state, action) => {
        state.loading = true;
    })

    builder.addCase("GetStartRecordingFromUsersSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.StartRecordingField = action.payload
    })
    builder.addCase("GetStartRecordingFromUsersError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })


    //Get Learner Class Initiated OTP
    builder.addCase("GetLearnerClassInitiatedOTPRequest", (state, action) => {
        state.loading = true;
    })

    builder.addCase("GetLearnerClassInitiatedOTPSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.LearnerClassInitiatedOTP = action.payload
    })
    builder.addCase("GetLearnerClassInitiatedOTPError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    //Get Learner All Driving Classes Data
    builder.addCase("GetLearnerAllDrivingClassesDataRequest", (state, action) => {
        state.loading = true;
    })

    builder.addCase("GetLearnerAllDrivingClassesDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.LearnerAllDrivingClassesData = action.payload
    })
    builder.addCase("GetLearnerAllDrivingClassesDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })


})
export const ToggleSignupReducer = createReducer({
    AuthPageName: "",
    Navigation: false,
    Done: false,
    userType: "",
    loginType: ""
}, (builder) => {
    builder.addCase("OpenLoginSignUp", (state, action) => {
        state.AuthPageName = action.AuthPageName;
        state.Navigation = action.Navigation;
        state.Done = action.Done;
        state.userType = action.userType;
        state.loginType = action.loginType;
    })
    builder.addCase("DoneLoginSignUp", (state, action) => {
        state.AuthPageName = action.AuthPageName;
        state.Done = action.Done;
    })
    builder.addCase("AgainOpenLoginSignUp", (state, action) => {
        state.AuthPageName = action.AuthPageName;
    })
})



// export const EnrollmentSuccess = createReducer(VehicleTypeInitialState, (builder) => {
//     builder.addCase("EnrollmentSuccess", (state, action) => {
//         state.UserInfo = action.payload;
//     })
// });
